// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nsection,\narticle,\nspan {\n  box-sizing: border-box;\n}\n\na {\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
